import * as tslib_1 from "tslib";
import React from 'react';
import StyledDialogActions from './StyledDialogActions';
var transformButtonToDialogAction = function (children) {
    return React.Children.map(children, function (node) {
        return React.isValidElement(node)
            ? React.cloneElement(node, {
                color: node.props.color || 'primary',
            })
            : node;
    });
};
function DialogActions(props) {
    return (React.createElement(StyledDialogActions, tslib_1.__assign({}, props), transformButtonToDialogAction(props.children)));
}
export default DialogActions;
//# sourceMappingURL=DialogActions.js.map